import { apiClient } from "./ApiClient";

export const retrieveAllOrdersApi = (orderType) =>
  apiClient.get(`/order-view/orders/${orderType}`);

export const retrieveFastOrdersApi = (orderType) =>
  apiClient.get(`/order-view/fast-orders/${orderType}`);

export const createOrderApi = (order) =>
  apiClient.post(`/order-view/add`, order);

export const cancelOrderApi = (orderId, order) =>
  apiClient.put(`/order-view/cancel-order/${orderId}`, order);

export const createMultipleOrdersApi = (orderList) =>
  apiClient.post(`/order-view/add-multiple`, orderList);

export const updateOrderApi = (orderId, order) =>
  apiClient.put(`/order-view/edit/${orderId}`, order);

  export const updateMultipleOrdersApi = (orderList) =>
  apiClient.put(`/order-view/edit/order-list`, orderList);

  export const approveOrderApi = (orderId) =>
    apiClient.put(`order-view/approve/${orderId}`);

export const retrieveFilteredOrdersApi = (order) =>
  apiClient.post(`/order-view/filter`, order);

export const retrieveFastFilteredOrdersApi = (order) =>
  apiClient.post(`/order-view/fast-filter`, order);

export const retrieveMaxOrderNumberApi = (orderType) =>
  apiClient.get(`/order-view/max-order-number/${orderType}`);

export const retrieveOrderByIdApi = (orderId) => 
  apiClient.get(`/order-view/orders/get/${orderId}`);

export const deleteOrdersApi = (orderIdList) =>
  apiClient.put(`/order-view/delete-list`, orderIdList);

export const retrieveSelectedOrdersByIdApi = (orderIdList, orderType) =>
  apiClient.post(`/order-view/orders/get-selected/${orderType}`, orderIdList);

export const retrieveOrdersShippingViewApi = (stakeholderId, orderType) =>
  apiClient.get(`/order-view/shipping-view`, {
    params: {
      stakeholderId:   stakeholderId,
      orderType:     orderType,
    }
  });

export const retrieveTotalCompanyOrdersApi = (orderType, year) =>
  apiClient.get(`/order-view/company-totals`, {
    params: {
      orderType:   orderType,
      year:     year,
    }
  });
  export const retrieveTotalStakeholderOrdersApi = (orderType, year) =>
  apiClient.get(`/order-view/stakeholder-totals`, {
    params: {
      orderType:   orderType,
      year:     year,
    }
  });
  export const retrieveOrderedNicotineTotalsApi = (orderType, year) =>
  apiClient.get(`/order-view/nicotine-totals`, {
    params: {
      orderType:   orderType,
      year:     year,
    }
  });

 export const retrieveMonthlyTotalsApi = (orderType, year) =>
  apiClient.get(`/order-view/monthly-totals`, {
    params: {
      orderType:   orderType,
      year:     year,
    }
  });

 export const retrieveDualAmountsApi = (year) =>
  apiClient.get(`/order-view/monthly-dual-totals`, {
    params: {
      year:     year,
    }
  });

 export const retrieveOrderPricesApi = (orderType, itemId) =>
  apiClient.get(`/order-view/prices`, {
    params: {
      orderType:   orderType,
      itemId:     itemId,
    }
  });

/**
 * Shipment Status Report API call.
 *
 * Fetches all active orders (PO + SO or one type) with boolean flags:
 *   hasSr – true when the order has at least one Shipment Request
 *   hasSi – true when the order has at least one Shipping Instruction
 *
 * @param {string|null} orderType  "VENDOR" | "CUSTOMER" | null (both)
 * @returns {Promise} Axios promise resolving to { data: OrderShipmentStatusView[] }
 */
export const retrieveShipmentStatusReportApi = (orderType) =>
  apiClient.get(`/order-view/shipment-status-report`, {
    params: orderType ? { orderType } : {},
  });